// @ts-nocheck
import Card from '@material-ui/core/Card';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import RefreshIcon from '@material-ui/icons/Autorenew';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { TABLE_HEADER_COLOR } from '../../_config/consts';
import * as UtilsActions from '../../redux/actions/utils.actions';
import EmptyView from '../EmptyView.jsx';
import ListLoadingView from '../ListLoadingView.jsx';
import MDTablePaginationActions from '../MDTable/MDTablePaginationActions.jsx';
import GatewayChip from './GatewayChip.jsx';
import { getPcuGatewayDisplay } from './powerControlUnitGatewayUtils.js';
import PowerStatusBadge from './PowerStatusBadge.jsx';

const styles = theme => ({
  table: {
    overflow: 'scroll',
  },
  tableColumnText: {
    fontWeight: 'bold',
    color: '#3f3f3f',
  },
  tableHeader: {
    padding: 5,
    paddingLeft: 25,
  },
  rowSelected: {
    backgroundColor: 'aliceblue !important',
  },
  rowHovered: {
    cursor: 'pointer',
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
  disabledInput: {
    display: 'none',
  },
  paginationText: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#3f3f3f',
  },
});

@connect(state => ({
  powerControlUnits: state.powerControlUnits,
}))
class PowerControlUnitsTableView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  onChangePage(event, page) {
    const { onChangePage } = this.props;
    if (onChangePage) {
      onChangePage(page);
    }
  }

  onSelectPCU(pcu) {
    const { onSelectPCU } = this.props;
    if (onSelectPCU) {
      onSelectPCU(pcu);
    }
  }

  onGatewayClick(gatewayId) {
    const { dispatch } = this.props;
    dispatch(push(`/gateways?gatewayId=${gatewayId}`));
  }

  renderTablePagination(page, rowsPerPage, totalElements, totalPages) {
    const { classes } = this.props;

    return (
      <TablePagination
        colSpan={0}
        count={!_.isUndefined(totalElements) ? totalElements : 0}
        rowsPerPage={!_.isUndefined(rowsPerPage) ? rowsPerPage : 0}
        page={!_.isUndefined(page) ? page : 0}
        labelRowsPerPage=" "
        classes={{
          input: classes.disabledInput,
        }}
        labelDisplayedRows={({ from, to, count }) => (
          <h4 className={classes.paginationText}>
            <Entity
              key={`${from}-${totalPages}-${count}`}
              entity="powerControlUnitsTablePagination"
              data={{
                currentPage: !_.isUndefined(page) ? page + 1 : 0,
                totalPages: !_.isUndefined(totalPages) ? totalPages : 0,
                count: !_.isUndefined(count) ? count : 0,
              }}
            />
          </h4>
        )}
        onChangePage={(event, newPage) => this.onChangePage(event, newPage)}
        ActionsComponent={() => (
          <MDTablePaginationActions
            count={totalElements}
            page={page}
            iconColor="#3f3f3f"
            lastPage={totalPages - 1}
            rowsPerPage={rowsPerPage}
            onChangePage={(event, newPage) => this.onChangePage(event, newPage)}
          />
        )}
      />
    );
  }

  render() {
    const {
      classes,
      powerControlUnits: { data: { content: pcus, pagination } },
      selectedPCU,
      isLoading,
      onRefresh,
      dispatch,
    } = this.props;

    const isUltra = dispatch(UtilsActions.isEnergyManagementUltra());

    const page = pagination && pagination.number ? pagination.number : 0;
    const rowsPerPage = pagination && pagination.size ? pagination.size : 10;
    const totalElements = pagination && pagination.totalElements ? pagination.totalElements : 0;
    const totalPages = pagination && pagination.totalPages ? pagination.totalPages : 0;

    if (isLoading) {
      return <ListLoadingView />;
    }

    if (!pcus || pcus.length === 0) {
      return <EmptyView title="noPowerControlUnits" subtitle="startPowerControlUnits" />;
    }

    return (
      <div className="list-view details-section">
        <Card style={{ overflow: 'scroll' }} elevation={4}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow style={{ backgroundColor: TABLE_HEADER_COLOR }}>
                <TableCell colSpan={3}>
                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <h3 className={classes.tableColumnText} style={{ color: '#3f3f3f', marginTop: 15, marginBottom: 15 }}>
                      <Entity entity="powerControlUnits" />
                    </h3>
                    {onRefresh && (
                      <IconButton onClick={() => onRefresh()} style={{ marginLeft: 10, marginTop: 5 }}>
                        <RefreshIcon style={{ color: '#3f3f3f', fontSize: 25 }} />
                      </IconButton>
                    )}
                  </div>
                </TableCell>
                {this.renderTablePagination(page, rowsPerPage, totalElements, totalPages)}
              </TableRow>
              <TableRow style={{ backgroundColor: 'white' }}>
                <TableCell className={classes.tableHeader}>
                  <h4 className={classes.tableColumnText}><Entity entity="name" /></h4>
                </TableCell>
                <TableCell className={classes.tableHeader}>
                  <h4 className={classes.tableColumnText}><Entity entity="powerStatus" /></h4>
                </TableCell>
                {isUltra && (
                  <TableCell className={classes.tableHeader}>
                    <h4 className={classes.tableColumnText}><Entity entity="presenceStatus" /></h4>
                  </TableCell>
                )}
                <TableCell className={classes.tableHeader}>
                  <h4 className={classes.tableColumnText}><Entity entity="automationEnabled" /></h4>
                </TableCell>
                <TableCell className={classes.tableHeader}>
                  <h4 className={classes.tableColumnText}><Entity entity="controllingGateway" /></h4>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {pcus.map((pcu) => {
                const isSelected = selectedPCU && selectedPCU.id === pcu.id;
                const { label, gatewayId, hasGateway } = getPcuGatewayDisplay(pcu);
                return (
                  <TableRow
                    key={pcu.id}
                    className={`${classes.row} ${classes.rowHovered} ${isSelected ? classes.rowSelected : ''}`}
                    onClick={() => this.onSelectPCU(pcu)}
                  >
                    <TableCell padding="dense" style={{ paddingLeft: 25 }}>
                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <h4 style={{ fontWeight: 'bold', color: '#3f3f3f', margin: 0 }}>{pcu.name}</h4>
                        {pcu.nominalLoadKw && (
                          <h5 style={{ fontSize: 12, color: '#666', margin: 0, marginTop: 4 }}>
                            {pcu.nominalLoadKw} kW
                          </h5>
                        )}
                      </div>
                    </TableCell>
                    <TableCell padding="dense" style={{ paddingLeft: 25 }}>
                      <PowerStatusBadge state={pcu.state} />
                    </TableCell>
                    {isUltra && (
                      <TableCell padding="dense" style={{ paddingLeft: 25 }}>
                        {pcu.presence !== null && pcu.presence !== undefined ? (
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            {pcu.presence ? (
                              <>
                                <CheckCircleIcon style={{ fontSize: 18, color: '#4caf50', marginRight: 5 }} />
                                <h5 style={{ margin: 0 }}>
                                  <Entity entity="present" />
                                </h5>
                              </>
                            ) : (
                              <>
                                <CancelIcon style={{ fontSize: 18, color: '#9e9e9e', marginRight: 5 }} />
                                <h5 style={{ margin: 0 }}>
                                  <Entity entity="notPresent" />
                                </h5>
                              </>
                            )}
                          </div>
                        ) : (
                          <h5 style={{ color: '#9e9e9e', margin: 0 }}>-</h5>
                        )}
                      </TableCell>
                    )}
                    <TableCell padding="dense" style={{ paddingLeft: 25 }}>
                      {pcu.automationEnabled ? (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <CheckCircleIcon style={{ fontSize: 20, color: '#4caf50', marginRight: 5 }} />
                          <h5 style={{ margin: 0 }}>
                            <Entity entity="enabled" key={`yes-${pcu.automationEnabled}`} />
                          </h5>
                        </div>
                      ) : (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <CancelIcon style={{ fontSize: 20, color: '#9e9e9e', marginRight: 5 }} />
                          <h5 style={{ margin: 0 }}>
                            <Entity entity="disabled" key={`no-${pcu.automationEnabled}`} />
                          </h5>
                        </div>
                      )}
                    </TableCell>
                    <TableCell padding="dense" style={{ paddingLeft: 25 }}>
                      {hasGateway ? (
                        <GatewayChip
                          label={label}
                          gatewayId={gatewayId}
                          onClick={gatewayId => this.onGatewayClick(gatewayId)}
                        />
                      ) : (
                        <h5 style={{ color: '#9e9e9e', margin: 0 }}>-</h5>
                      )}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
            <TableFooter>
              <TableRow style={{ backgroundColor: TABLE_HEADER_COLOR }}>
                {this.renderTablePagination(page, rowsPerPage, totalElements, totalPages)}
              </TableRow>
            </TableFooter>
          </Table>
        </Card>
      </div>
    );
  }
}

export default withStyles(styles)(PowerControlUnitsTableView);
